export const MEDIA_EXTENSIONS = {
    video: ["mp4", "webm", "avi"],
    image: ["png", "webp", "jpg", "svg"],
    "lottie-json": ["json"],
    "lottie-dotlottie": ["lottie"],
    "youtube-iframe": ["youtube-embed"],
};
const VIDEO_TYPES = {
    mp4: "video/mp4",
    webm: "video/webm",
    avi: "video/x-msvideo",
};
const getMediaFileExtension = (fileUrl) => fileUrl.includes(".") ? fileUrl.split(".").pop() : undefined;
const isYouTubeEmbed = (url) => {
    const regex = /(?:www\.)?youtube\.com\/embed\//;
    return regex.test(url);
};
const getExtensionForExtensionlessMedia = (fileUrl) => {
    if (isYouTubeEmbed(fileUrl)) {
        return "youtube-embed";
    }
    return undefined;
};
export const getMediaType = (fileUrl) => {
    if (!fileUrl) {
        return undefined;
    }
    const extension = getExtensionForExtensionlessMedia(fileUrl) ||
        getMediaFileExtension(fileUrl);
    if (!extension) {
        return undefined;
    }
    return Object.entries(MEDIA_EXTENSIONS).find(([, extensions]) => extensions.includes(extension?.toLowerCase()))?.[0];
};
export const getVideoType = (fileUrl) => {
    if (!fileUrl) {
        return undefined;
    }
    const extension = getMediaFileExtension(fileUrl);
    if (!extension) {
        return undefined;
    }
    return VIDEO_TYPES[extension?.toLowerCase()];
};
